// import 'react-app-polyfill/ie11';
// import 'react-app-polyfill/stable';
import 'regenerator-runtime/runtime';

import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.scss';
import themes from 'devextreme/ui/themes';
import ruMessages from 'devextreme/localization/messages/ru.json';
import { locale, loadMessages } from 'devextreme/localization';
import App from './App';
import localization from './utils/localization';
import * as serviceWorker from './serviceWorker';
import { getLocale } from './utils/functions';

if (!window.localStorage.theme) {
  window.localStorage.setItem('theme', 'material.blue.light');
}

if (window.localStorage.getItem('theme') === 'material.blue.light') {
  document.body.className = 'material-blue-light';
} else {
  document.body.className = 'material-blue-dark';
}

if (getLocale() === 'ru') {
  document.title = 'Северсталь-Инфоком | Типовой удаленный склад';
} else {
  document.title = 'Severstal-Infocom | Typical Remote Stockyard';
}

themes.ready(() => themes.current(window.localStorage.theme));

loadMessages(ruMessages);
loadMessages(localization);
locale(getLocale());

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
